module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("G")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("D")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e4df861","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/iview-ui/Row.vue
// module id = 565
// module chunks = 1